import { render, staticRenderFns } from "./OpeningType.vue?vue&type=template&id=47fc91b4&scoped=true&"
import script from "./OpeningType.vue?vue&type=script&lang=js&"
export * from "./OpeningType.vue?vue&type=script&lang=js&"
import style0 from "./OpeningType.vue?vue&type=style&index=0&id=47fc91b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fc91b4",
  null
  
)

export default component.exports